export default function reducer(
    state = {
        siteName: '',
        id: 0,
        siteLogo: '',
        colours: {},
        currentNavTab: 0,
        currentPage: '',
        supportEmail: '',
        address: '',
        contactGateApiKey: '',
        customFooter: '',
        usersMustBeAuthenticated: false,
        campaignView: 'list',
        npsEnabled: false,
        isCapMarketing: false,
        siteDrawer: {
            isOpen: false,
            showClose: false,
            direction: 'right',
            content: null,
            firstRun: false,
            width: null,
            className: '',
            onClose: undefined
        },
        connectionError: '',
        fullpage: null,
        hasBanner: false
    },
    action
) {
    switch (action.type) {
        case 'INIT_SITE_DATA_LOAD': {
            // Merge site config from the API; do not wipe session UI state such as the drawer.
            const siteData = { ...(action.payload || {}) }
            delete siteData.siteDrawer
            delete siteData.currentPage
            delete siteData.currentNavTab
            delete siteData.connectionError
            delete siteData.snackbar
            delete siteData.fullpage
            delete siteData.hasBanner
            delete siteData.campaignView
            return {
                ...state,
                ...siteData
            }
        }

        case 'CHANGE_MAINNAV_TAB': {
            var newState = {
                ...state,
                currentNavTab: action.payload
            }
            return newState
        }

        case 'CHANGE_SITE_DRAWER': {
            var newState = {
                ...state,
                siteDrawer: action.payload
            }
            return newState
        }
        case 'CHANGE_SITE_DRAWER_WIDTH': {
            return {
                ...state,
                siteDrawer: {
                    ...(state.siteDrawer || {}),
                    width: action.payload
                }
            }
        }
        case 'CHANGE_PAGE': {
            var newState = {
                ...state,
                currentPage: action.payload
            }
            return newState
        }
        case 'CHANGE_CAMPAIGN_VIEW': {
            console.log(state.campaignView, action.payload)
            return { ...state, campaignView: action.payload }
        }
        case 'SET_CONNECTION_ERROR':
            return { ...state, connectionError: action.payload }
        case 'ALTER_SNACKBAR': {
            return { ...state, snackbar: action.payload }
        }
        case 'ALTER_FULLPAGE': {
            return { ...state, fullpage: action.payload }
        }
        case 'SET_HAS_BANNER': {
            return { ...state, hasBanner: action.payload }
        }
    }
    return state
}
